import React from "react";
import "./Muhammadabad.css"; // Reuse your CSS
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

const Mubarakpur = () => {
  return (
    <div className="dp-page">

      <Helmet>
        <title>Popular Aluminium Works in Mubarakpur, Uttar Pradesh | Trusted Fabricators</title>
        <meta
          name="description"
          content="Find reliable aluminium works in Mubarakpur, Uttar Pradesh. Skilled local fabricators provide sliding windows, aluminium doors, partitions, kitchen cupboards, and custom aluminium solutions for homes and offices."
        />
        <meta
          name="keywords"
          content="Aluminium Works Mubarakpur UP, Aluminium Fabricators, Sliding Windows, Aluminium Doors, Partitions, Kitchen Cupboards, Custom Aluminium Work, Window Installation"
        />
        <meta name="robots" content="index, follow" />

        {/* Open Graph / Social */}
        <meta property="og:title" content="Popular Aluminium Works in Mubarakpur, Uttar Pradesh" />
        <meta
          property="og:description"
          content="Trusted aluminium fabricators providing sliding windows, doors, partitions, kitchen cupboards, and custom aluminium solutions for homes and offices in Mubarakpur, Uttar Pradesh."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={window.location.href} />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Popular Aluminium Works in Mubarakpur, Uttar Pradesh" />
        <meta
          name="twitter:description"
          content="Skilled aluminium fabricators providing sliding windows, doors, partitions, kitchen cupboards, and custom aluminium solutions in Mubarakpur, Uttar Pradesh."
        />
      </Helmet>

      {/* HERO SECTION */}
      <section className="dp-section">
        <div className="dp-container dp-split">
          <div>
            <h1>Popular Aluminium Works in Mubarakpur, Uttar Pradesh</h1>
            <p>
              Mubarakpur, Uttar Pradesh, is a notable hub for aluminium works, including fabrication, sliding windows, doors, partitions, and kitchen cupboards. With a growing construction and renovation market, residents and businesses now seek reliable local fabricators who can provide durable, stylish, and low-maintenance aluminium solutions.
            </p>
          </div>
          <img
            src="https://res.cloudinary.com/di82vlbpn/image/upload/v1765908421/WhatsApp_Image_2025-12-16_at_10.06.41_AM_mdtfzb.jpg"
            alt="aluminium-works-mubarakpur"
          />
        </div>
      </section>

      {/* WHY ALUMINIUM WORKS */}
      <section className="dp-section">
        <div className="dp-container">
          <h2>Why Aluminium Works Are Essential in Mubarakpur</h2>
          <p>
            Aluminium works in Mubarakpur are in high demand because they combine strength, modern aesthetics, and low maintenance. Local fabricators specialize in sliding windows, aluminium doors, partitions, kitchen cupboards, and glass fittings, ensuring every installation is precise and durable for both residential and commercial spaces.
          </p>
          <p>
            Powder-coated frames, toughened glass, and custom designs are commonly offered, making aluminium solutions adaptable to various architectural styles and budgets.
          </p>
        </div>
      </section>

      {/* TRUSTED FABRICATORS */}
      <section className="dp-section dp-box-layout">
        <img
          src="https://res.cloudinary.com/di82vlbpn/image/upload/v1765616717/WhatsApp_Image_2025-12-11_at_10.52.30_PM_1_fynu60.jpg"
          alt="trusted-fabricators-mubarakpur"
        />
        <div className="dp-box">
          <h2>Trusted Aluminium Fabricators in Mubarakpur</h2>
          <p>
            Many customers in Mubarakpur prefer local fabricators for personalized service, fast installations, and reliable after-sales support. Experienced workshops handle everything from measurement to final installation, guiding clients on aluminium grades, glass thickness, and hardware for optimal performance.
          </p>
          <p>
            These fabricators often serve nearby regions as well, offering professional service, transparent pricing, and timely project completion.
          </p>
        </div>
      </section>

      {/* SLIDING WINDOWS & DOORS */}
      <section className="cp-page">
        <section className="cp-scroll">
          <div className="cp-scroll-text">
            <h2>Aluminium Sliding Windows and Doors</h2>
            <p>
              Sliding aluminium windows are particularly popular in Mubarakpur for their space-saving design, smooth operation, and modern appearance. They are ideal for bedrooms, kitchens, offices, and balconies. Aluminium sliding doors with glass panels enhance shopfronts and commercial interiors by combining elegance, security, and durability.
            </p>
          </div>
          <div className="cp-scroll-img"></div>
        </section>
      </section>

      {/* CUSTOM FABRICATION */}
      <section className="dp-section">
        <div className="dp-container">
          <h2>Custom Aluminium Fabrication and Glass Work in Mubarakpur</h2>
          <p>
            Fabricators in Mubarakpur offer custom solutions for aluminium partitions, window grills, office cabins, kitchen cupboards, and glass panels. Custom work ensures proper fitting, high-quality finishing, and long-term durability. Many workshops also provide repair and replacement services for locks, sliding systems, and glass installations.
          </p>
        </div>
      </section>

      {/* SERVICE AREAS */}
      <section className="dp-section">
        <div className="dp-container dp-box-layout">
          <img
            src="https://res.cloudinary.com/di82vlbpn/image/upload/v1766165233/Screenshot_2025-12-19_225650_raucxl.png"
            alt="service-areas-mubarakpur"
          />
          <div className="dp-box">
            <h2>Serving Mubarakpur and Surrounding Regions</h2>
            <p>
              Aluminium works in Mubarakpur are available across nearby towns, villages, and marketplaces. This makes it easy for customers to schedule measurements, site visits, and installation services without delays. Local service coverage ensures timely project completion and budget-friendly solutions for homeowners, shopkeepers, and builders.
            </p>
          </div>
        </div>
      </section>

      {/* CONTENT SECTION */}
      <section className="aluminium-content">
        <div className="container">
          <h1>Choosing Aluminium Works in Mubarakpur</h1>
          <p>
            Mubarakpur has grown into a trusted market for aluminium fabrication, glass works, and UPVC solutions. Local dealers provide sliding windows, aluminium doors, partitions, kitchen cupboards, and custom glass work for residential and commercial projects.
          </p>

          <h2>Top Aluminium Fabricators in Mubarakpur</h2>
          <p>
            Leading fabricators specialize in aluminium windows, doors, partitions, and decorative grills. They ensure high-quality workmanship, timely delivery, and durable installations for homes and commercial buildings.
          </p>

          <h2>Top Aluminium Door Dealers in Mubarakpur</h2>
          <p>
            Aluminium doors in Mubarakpur are highly valued for durability, security, and aesthetic appeal. Trusted dealers offer a variety of styles suitable for homes, offices, and shops.
          </p>

          <h2>Kitchen Cupboard Aluminium Works in Mubarakpur</h2>
          <p>
            Aluminium kitchen cupboards are popular due to their easy maintenance, durability, and modern look. Fabricators provide custom designs to fit the layout and style of your home or office perfectly.
          </p>

          <h2>Glass and Partition Works in Mubarakpur</h2>
          <p>
            Fabricators also offer services for toughened glass panels, partitions, and ACP sheets. These installations enhance interiors, ensure safety, and provide a contemporary appearance for homes, offices, and commercial spaces.
          </p>

          <h2>Top Hardware Dealers in Mubarakpur</h2>
          <p>
            Hardware dealers supply locks, handles, fittings, and other accessories for aluminium, UPVC, and glass works, ensuring smooth operation and long-lasting performance.
          </p>
        </div>
      </section>

      {/* CTA */}
      <section className="dp-cta">
        <h2>Book Your Aluminium Work Today in Mubarakpur, Uttar Pradesh</h2>
        <Link to="/contact"><button>Contact Us</button></Link>
      </section>

    </div>
  );
};

export default Mubarakpur;
